import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface ClienteRanking {
    id: number
    nome: string
    telefone: string | null
    email: string
    totalSelos: number | null
    totalCompras: string | null
    quantidadePedidos: number | null
}

export interface FiltroRanking {
    dataInicio: string
    dataFinal: string
    tipoRanking: number
    apenasPrimeiraCompra: number
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    ) {
        const d = data as RespostaErroRaw
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterRankingClientes = async function (
    authorization: string,
    filtro: FiltroRanking
): Promise<ClienteRanking[] | ErroApi> {
    try {
        const params = new URLSearchParams({
            dataInicio: filtro.dataInicio,
            dataFinal: filtro.dataFinal,
            tipoRanking: String(filtro.tipoRanking),
            apenasPrimeiraCompra: String(filtro.apenasPrimeiraCompra === 1),
        })
        const response = await api
            .get<ClienteRanking[] | RespostaErroRaw>(
                `fornecedor/ObterRankingClientes?${params.toString()}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as ClienteRanking[]
    } catch (error) {
        RegistrarLogErro(error, "ObterRankingClientes", JSON.stringify(filtro))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
